import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
export class MinutesSecondsPipe {
    transform(value) {
        const minutes = Math.floor(value / 60);
        return (minutes +
            ':' +
            Math.floor(value - minutes * 60)
                .toString()
                .padStart(2, '0'));
    }
    static { this.ɵfac = function MinutesSecondsPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MinutesSecondsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "minutesSeconds", type: MinutesSecondsPipe, pure: true, standalone: false }); }
}
//# sourceMappingURL=minutes-seconds.pipe.js.map